import React from "react";
import { Card } from "primereact/card";
import { Link } from "react-router";

const EXAMPLE_SPECIES = [
  { name: "Canis lupus", commonName: "Gray Wolf" },
  { name: "Lissachatina fulica", commonName: "Giant African Snail" },
  { name: "Diaemus youngi", commonName: "White-winged Vampire Bat" },
  { name: "Asterias rubens", commonName: "Common Starfish" },
  { name: "Acinonyx jubatus", commonName: "Cheetah" },
  { name: "Grimpoteuthis discoveryi", commonName: "Dumbo Octopus" },
  { name: "Neocaridina davidi", commonName: "Cherry Shrimp" },
  { name: "Hippocampus hippocampus", commonName: "Short-snouted Seahorse" },
  { name: "Milnesium tardigradum", commonName: "Water Bear" },
];

export const ExampleSpeciesGrid = () => {
  return (
    <div className="flex justify-content-center w-full mb-5">
      <Card className="w-full md:w-10 lg:w-8 example-species-card">
        <h2 className="section-title">Example Species</h2>
        <div className="grid">
          {EXAMPLE_SPECIES.map(({ name, commonName }) => (
            <div key={name} className="col-12 md:col-6 lg:col-4">
              <Link
                to={`?species=${encodeURIComponent(name)}`}
                className="species-link"
              >
                <div>{name}</div>
                <div className="common-name">({commonName})</div>
              </Link>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};
